import api from '@/services/api'
import type {
  ClosePositionsRequest,
  ClosePositionsResponse,
  PrepareApiRequest,
  CreateSwapOrdersRequest,
  CreateSwapOrdersResponse,
  CreateSwapOrderRequest,
  CancelOrdersResponse,
} from './types'
import type { CcxtOrderData } from '@/utils/types'
import { isUndefined } from 'lodash'
import type { ApiKeyType } from '../api-keys-v2-service/types'

export const TradeV2Service = {
  prepareProfile(profileNum: number, data: PrepareApiRequest) {
    return api.post(`/v2/trade/swap/prepare/${profileNum}`, data)
  },
  prepareSingleProfile(
    exchange: string,
    asset: string,
    profileNum: number,
    keyType: ApiKeyType,
    leverage: number,
    marginMode: 'isolated' | 'cross',
    quote?: string,
  ) {
    const quoteParam = quote ? `&quote=${quote}` : ''
    return api.get(
      `/v2/trade/prepare/${exchange}/${asset}/${profileNum}/${keyType}/?leverage=${leverage}&margin_mode=${marginMode}${quoteParam}`,
    )
  },
  createSwapOrders(profileNum: number, data: CreateSwapOrdersRequest) {
    return api.put<CreateSwapOrdersResponse>(`/v2/trade/x-swap/${profileNum}`, data)
  },
  createSwapOrder(profileNum: number, data: CreateSwapOrderRequest) {
    if (isUndefined(data.margin_mode)) {
      data.margin_mode = 'isolated'
    }
    if (isUndefined(data.market_order)) {
      data.market_order = false
    }
    return api.put<[number, number, CcxtOrderData]>(`/v2/trade/swap/${profileNum}`, data)
  },
  createSwapOrderPro(profileNum: number, data: CreateSwapOrderRequest, keyType?: ApiKeyType) {
    if (!keyType) {
      keyType = 'dex_cex'
    }
    return api.put<[number, number, CcxtOrderData]>(
      `/v2/trade/swap-order/${profileNum}?key_type=${keyType}`,
      data,
    )
  },
  closeSwapPositions(profileNum: number, data: ClosePositionsRequest) {
    return api.post<ClosePositionsResponse>(`/v2/trade/x-swap/positions/close/${profileNum}`, data)
  },
  cancelSwapOrders(profileNum: number, data: ClosePositionsRequest) {
    return api.post<CancelOrdersResponse>(`/v2/trade/x-swap/orders/cancel/${profileNum}`, data)
  },
  fetchBalance(
    exchange: string,
    profileNum: number,
    marketType: 'spot' | 'swap',
    keyType: ApiKeyType,
  ) {
    return api.get<any>(
      `/v2/trade/balance/${marketType}/${exchange}/${profileNum}?key_type=${keyType}`,
    )
  },
}
